'use client'
import React, {useCallback} from 'react'
import Link from 'next/link'
import { Button } from '@nextui-org/react'
import { usePathname } from 'next/navigation'


export default function ButtonPagination(props) {
  const {
    label, 
    icon:Icon, 
    iconPlacement="before", 
    page=1,
    searchParams={}
  } = props
  const pathname = usePathname()
  
  const createQueryString = useCallback(
    (name, value) => {
      const newParams = {}
      Object.keys(searchParams).forEach(key => {
        newParams[key] = searchParams[key]
      })
      newParams[name] = value
      if(value === 'null') delete newParams[name]
      const queryString = new URLSearchParams(newParams).toString()
      return queryString
    },
    [searchParams]
  )

  const uri = `${pathname}?${createQueryString('page', page)}`
  return (
    <>
      <Button
        as={Link}
        href={`${uri}#list`}
      >
        {iconPlacement === "before" && <div className="mr-1 inline-block">{Icon}</div>} 
        {label} 
        {iconPlacement === "after" && <div className="ml-1 inline-block">{Icon}</div>}
        
      </Button>
    </>
  )
}
